import type { LinkPlatform, LinkPreview } from '@/services/accountLink';

/** Названия для подписей — не ветвление логики по площадке. */
export const PLATFORM_NAMES: Record<LinkPlatform, string> = {
  telegram: 'Telegram',
  vk: 'ВКонтакте',
  ok: 'Одноклассники',
};

export function formatCode(code: string): string {
  return `${code.slice(0, 3)} ${code.slice(3)}`;
}

export function formatSeconds(total: number): string {
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/** Что произойдёт — до подтверждения, а не после (ADR-041, п. 7). */
export function describeOutcome(preview: LinkPreview): string {
  const survivor = PLATFORM_NAMES[preview.survivorPlatform];
  const absorbed = PLATFORM_NAMES[preview.absorbedPlatform];
  const main = `Аккаунт ${absorbed} присоединится к аккаунту ${survivor}. Баланс и история будут из ${survivor}.`;

  return preview.burnedCredits > 0
    ? `${main} Кредиты аккаунта ${absorbed} сгорят: ${preview.burnedCredits}.`
    : main;
}
